import { ConfirmDialog } from '@ui';
import { useCallback, useRef, useState, type ReactNode } from 'react';

// Confirmation instead of window.confirm (facts model widget_ui, П307): the action runs after «да», exactly once; while
// the dialog is open another ask does not open a second one (it resolves false).

export interface ConfirmAsk {
  title: ReactNode;
  text?: ReactNode;
  confirmLabel?: string;
  tone?: 'danger' | 'primary';
}

interface Pending extends ConfirmAsk {
  resolve: (yes: boolean) => void;
}

export function useConfirm(): { confirm: (ask: ConfirmAsk) => Promise<boolean>; dialog: ReactNode } {
  const [pending, setPending] = useState<Pending | null>(null);
  const open = useRef(false);

  const confirm = useCallback((ask: ConfirmAsk) => {
    if (open.current) return Promise.resolve(false);
    open.current = true;
    return new Promise<boolean>((resolve) => setPending({ ...ask, resolve }));
  }, []);

  const finish = (yes: boolean) => {
    if (!pending) return;
    open.current = false;
    pending.resolve(yes);
    setPending(null);
  };

  const dialog = (
    <ConfirmDialog
      open={pending !== null}
      title={pending?.title ?? ''}
      tone={pending?.tone ?? 'danger'}
      confirmLabel={pending?.confirmLabel ?? 'Удалить'}
      onConfirm={() => finish(true)}
      onCancel={() => finish(false)}
    >
      {pending?.text}
    </ConfirmDialog>
  );
  return { confirm, dialog };
}
